import React, { useState } from 'react'
import { useAlert } from 'react-alert'

const EmailForm = () => {
  const alert = useAlert()

  const [message, handleChange] = useState('')
  const name = 'Personal Website of Nick Gowdy'
  const email = 'nickgowdy87@gmail.com'

  const handleSubmit = (event) => {
    const templateId = 'template_SXwAm3UP'
    const serviceId = '02091987'

    sendFeedback(templateId, serviceId,
      {
        message_html: message,
        from_name: name,
        reply_to: email })
  }

  const sendFeedback = (templateId, serviceId, variables) => {
    window.emailjs.send(serviceId, templateId, variables).then(res => {
      handleChange('')
      alert.success('Your message has been submitted.')
    }).catch(err => console.error('Oh well, you failed. Here some thoughts on the error that occured:', err))
  }

  return (
    <form className='test-mailing'>
      <div>
        <textarea
          id='test-mailing'
          name='test-mailing'
          onChange={e => handleChange(e.target.value)}
          placeholder='Write your message here...'
          required
          value={message}
          style={{ width: '100%', height: '150px' }} />
      </div>
      <input type='button' value='Submit' onClick={handleSubmit} className='btn btn--submit' />
    </form>
  )
}

export default EmailForm
